const chrome = function() {
    const chromes = document.querySelectorAll('.work__chrome');
    for (let i = 0; i < chromes.length; i++) {
        const chrome = chromes[i];
        const image_wrapper = chrome.querySelector('.work__chrome__image');
        if (image_wrapper) {
            const image = image_wrapper.querySelector('img');
            if (image) {
                // speed 
                const speed = 25;
                const start_delay = 2500;
                // work out the height of image_Wrapper
                const image_wrapper_height = image_wrapper.offsetHeight;
                // work out the height of the image
                const image_height = image.offsetHeight;

                // if the image is taller than the wrapper, add a class to the wrapper
                if (image_height > image_wrapper_height) {
                    image_wrapper.classList.add('work__chrome__image--animated');
                    // Now work out the difference in height between the image and the wrapper
                    const height_difference = image_height - image_wrapper_height;
                    //  Set a css var on the image that will be used to animate the image up and down
                    image.style.setProperty('--height-difference', `-${height_difference}px`);
                    image.style.setProperty('--anim-speed', `${start_delay + (height_difference * speed)}ms`);
                }
            }
        }
    }
};

export {chrome};
